import createEmojiRegexp from "emoji-regex";

import { isNotNullable } from "../common";

const EMOJI_REGEXP = createEmojiRegexp();

export default function isTextStandaloneEmoji(text: string): boolean {
  const emojiMatch = text.match(EMOJI_REGEXP);

  return (
    isNotNullable(emojiMatch) &&
    emojiMatch.length === 1 &&
    emojiMatch[0] === text
  );
}
